import React, { memo, useState } from 'react'
import { useFilter } from './Filter'
import { StyledDropdown } from './styles'

type DropdownProps = {
  id: string
  label?: string
  options?: { label: string; value: any }[]
}

const UnMemoizeFilterDropdown = ({ id, label, options }: DropdownProps) => {
  const [labelText, setLabelText] = useState(label)
  const { onChange } = useFilter()
  const [hide, setHide] = useState(true)

  const onSelect = React.useCallback(
    (value: string | undefined, label: string | undefined) => {
      setLabelText(label)
      onChange(id, value as string)
      setHide(true)
    },
    [onChange, id],
  )

  return (
    <StyledDropdown onMouseLeave={() => setHide(true)}>
      <div
        onMouseEnter={() => setHide(true)}
        onClick={() => setHide(!hide)}
      >
        <span className='text-label'> {labelText}</span>
        <i className="fa fa-angle-down" />
      </div>
      <ul className={hide ? 'hidden' : 'show'}>
        <li
          key={label}
          onClick={() => onSelect(undefined, label)}
        >
          <label>{label}</label>
        </li>
        {options?.map((option, i) => (
          <li
            key={`${option.value}-${i}`}
            onClick={() => onSelect(option.value, option.label)}
          >
            <label>{option.label}</label>
          </li>
        ))}
      </ul>
    </StyledDropdown>
  )
}

export const FilterDropdown = memo(UnMemoizeFilterDropdown)
